import getTextWidth from './get-text-width';

// Labeled drag trigger styles that needed for element width calculation
// are stored as custom CSS properties to get and share them easier
function getCssCustomPropValue(prop, targetDocument) {
  return getComputedStyle(targetDocument.documentElement).getPropertyValue(prop);
}

function getCssCustomPropNumericValue(prop, targetDocument) {
  return parseInt(getCssCustomPropValue(prop, targetDocument), 10);
}

function getLabelTriggerWidth(label, isDragTrigger = false) {
  const labelFontSize = getCssCustomPropValue('--ws-trigger-label__font-size', document);
  const labelFontFamily = getCssCustomPropValue('--ws-trigger-label__font-family', document);
  const labelTextWidthRaw = getTextWidth(label, `${labelFontSize} ${labelFontFamily}`, document);
  const labelMaxWidth = 140;
  const textEllipsisThreshold = 2; // Prevent text-overflow to be triggered too early
  const labelTextWidth =
    labelTextWidthRaw < labelMaxWidth
      ? labelTextWidthRaw + textEllipsisThreshold
      : labelMaxWidth + textEllipsisThreshold;

  const triggerInnerPadding = getCssCustomPropNumericValue('--ws-trigger__inner-padding', document);
  const labelPaddingLeft = getCssCustomPropNumericValue(
    isDragTrigger ? '--ws-drag-trigger-label__padding-left' : '--ws-trigger-label__padding-left',
    document
  );
  const labelPaddingRight = getCssCustomPropNumericValue(
    isDragTrigger ? '--ws-drag-trigger-label__padding-right' : '--ws-trigger-label__padding-right',
    document
  );

  return triggerInnerPadding * 2 + labelPaddingLeft + labelTextWidth + labelPaddingRight;
}

export default getLabelTriggerWidth;
